module.exports = __webpack_public_path__ + "img/scene3.917417bd.png";